module.exports = __webpack_public_path__ + "img/资源 386.57223092.png";